var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphonesGrayBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#EDF2FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67578 11.7108C7.67578 8.51792 10.2713 6 13.4729 6C16.6746 6 19.2701 8.51792 19.2701 11.7108",
    stroke: "#60727E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5889 19.1907C17.2541 19.0308 18.5439 18.5594 19.0447 17.2245",
    stroke: "#60727E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48797 11.7106H8.7418V17.1721H7.48797C6.66618 17.1721 6 16.5077 6 15.6882V13.1944C6 12.3749 6.66618 11.7106 7.48797 11.7106Z",
    stroke: "#60727E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8844 21.0002C14.8431 21.0002 15.6204 20.2251 15.6204 19.269C15.6204 18.3129 14.8431 17.5378 13.8844 17.5378C12.9257 17.5378 12.1484 18.3129 12.1484 19.269C12.1484 20.2251 12.9257 21.0002 13.8844 21.0002Z",
    stroke: "#60727E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.512 11.7106H18.2014V17.1721H19.512C20.3338 17.1721 21 16.5077 21 15.6882V13.1944C21 12.3749 20.3338 11.7106 19.512 11.7106Z",
    stroke: "#60727E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphonesGrayBackground);
export default __webpack_public_path__ + "static/media/HeadphonesGrayBackground.f29ebc45dc9d77b40551e9a4b381adbd.svg";
export { ForwardRef as ReactComponent };